import { RootState } from "@/models/RootState.type";
import { AppDispatch } from "@/models/AppDispatch.type";
import { createListenerMiddleware } from "@reduxjs/toolkit";
import {
  fetchStudentAssignments,
  fetchTeacherAssignments,
  getFetchAssignmentInputs,
  resetWeekState,
  updateWeeklyPlanDates,
} from "../slices";

export const addWeekChangeListenerMiddleware = (
  listenerMiddleware: ReturnType<typeof createListenerMiddleware>
) => {
  listenerMiddleware.startListening.withTypes<RootState, AppDispatch>()({
    actionCreator: updateWeeklyPlanDates,
    effect: async (action, listenerApi) => {
      try {
        const store = listenerApi.getState() as RootState;
        const fetchInputs = getFetchAssignmentInputs(store);

        if (!fetchInputs) {
          throw new Error(`invalid inputs`);
        }

        listenerApi.dispatch(resetWeekState());
        listenerApi.dispatch(
          fetchTeacherAssignments({
            ...fetchInputs,
          }) as any
        );
        listenerApi.dispatch(
          fetchStudentAssignments({
            ...fetchInputs,
          }) as any
        );
      } catch (error) {
        console.error("Error fetching assignments on week change:", error);
        // TODO dispatch a fetch retry action maybe?
        // listenerApi.dispatch(setLoading(AsyncLoadingState.ERROR));
      }
    },
  });
};
